import React, { useEffect, useState } from 'react';
import './DocCard.scss';
import '../../components/Filters/Filters.scss';
import { CreatableTechToolsSelect } from '../CreatableTechToolsSelect';
import { Watchlist } from '../../services/Contexture/Watchlist';
import { toast } from 'react-toastify';
const selectStyles = {
  control: (styles) => ({ ...styles, backgroundColor: 'white' }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: '#fff',
      color: isDisabled ? '#ccc' : isSelected ? '#fcb12e' : '#4D5C6D',
      ':hover': {
        color: '#fcb12e',
        cursor: 'pointer',
      },
      ':focus': {
        color: '#fcb12e',
        cursor: 'pointer',
      },
      ':active': {
        color: '#fcb12e',
        cursor: 'pointer',
      },
    };
  },
  multiValue: (styles, { data }) => {
    return {
      ...styles,
      backgroundColor: 'rgb(158, 13, 61)',
      color: '#fff',
      fontWeight: 700,
    };
  },
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: data.color,
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: data.color,
  }),
};
const AddTopics = ({
  tags = [],
  docId,
  popoverLabel,
  setShowAddTopicsPopover,
  onTagsUpdate,
  documentTags = [],
  fetchTags,
  profileId
}) => {
  const tagOptions = tags?.map((item) => ({ label: item?.name, value: item?.id }))
  const [selectedValues, setSelectedValues] = useState([]);

  useEffect(() => {
    if (documentTags?.length) {
      const selTags = documentTags?.map((item) => ({ label: item, value: item }));
      setSelectedValues(selTags);
    }
  }, [documentTags]);

  const handleSelectOnChange = async (selectedOptions, actionMeta) => {
    const { action, option, removedValue } = actionMeta;

    setSelectedValues(selectedOptions || []);
    let toastId;

    try {
      // ADD TAG
      if (action === "select-option") {
        toastId = toast.loading(`Adding "${option.label}"...`);

        await Watchlist.addTag(docId, { tag: option.label, profileId });
        toast.update(toastId, {
          render: `Tag "${option.label}" added successfully!`,
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });

        onTagsUpdate?.("add", option.label);
      }

      // REMOVE TAG
      if (action === "remove-value") {
        toastId = toast.loading(`Removing "${removedValue.label}"...`);

        await Watchlist.removeTag(docId, { tag: removedValue.label, profileId });
        toast.update(toastId, {
          render: `Tag "${removedValue.label}" removed successfully!`,
          type: "success",
          isLoading: false,
          autoClose: 2000,
        });

        onTagsUpdate?.("remove", removedValue.label);
      }

    } catch (error) {
      toast.update(toastId, {
        render: "Tag update failed",
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
      console.error(error);
    }
  };

  const handleOnCreateNewOption = async (inputValue) => {

    if (!inputValue.trim()) return;
    let toastId;

    try {
      toastId = toast.loading(`Adding "${inputValue}"...`);

      await Watchlist.addTag(docId, { tag: inputValue.trim(), profileId });
      toast.update(toastId, {
        render: `Tag "${inputValue}" added successfully!`,
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });

      onTagsUpdate?.('add', inputValue.trim());
      fetchTags?.(true);
      window.dispatchEvent(new Event('refreshDocLists'));
    } catch (error) {
      toast.update(toastId, {
        render: "Tag update failed",
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
      console.error('Error creating tag:', error);
    }
  }

  return (
    <div className="add-topic-popover filters-popover">
      <div className="filters-popover-header">
        <span>{popoverLabel || 'Select Tags'}</span>
        <button
          type="button"
          className="filters-popover-close"
          onClick={() => setShowAddTopicsPopover(false)}
        >
          ×
        </button>
      </div>

      <ul className="filters-popover-list">
        <li className="filters-popover-row">

          <div className="filters-popover-expanded">
            <div className='mt-2'>
              <CreatableTechToolsSelect
                isMulti
                isClearable={false}
                styles={selectStyles}
                placeholder={
                  'Select tags or create new ones'
                }
                value={selectedValues}
                options={tagOptions}
                isLoading={false}
                onChange={handleSelectOnChange}
                onCreateOption={(inputValue) =>
                  handleOnCreateNewOption(inputValue)
                }
                data-testid='tags-dropdown'
                noOptionsMessage={() =>
                  'No tags found. Type to create a new one.'
                }
                formatCreateLabel={(inputValue) => `Create "${inputValue}"`}
                getUserId={() => ''}
                onDeleteOption={() => { }}
              />
            </div>
          </div>
        </li>
      </ul>
    </div>
  )
}

export default AddTopics